import { getEditorString, TNodeEntry, unwrapNodes } from '@udecode/plate';
import { BufferEditor } from '~/editor/BufferEditor/types.plate';
import { setNodeValidityAgainstRegex } from './setNodeValidityAgainstRegex';
import {
  AutocompleteInputElement,
  AutocompleteInputElementInterface,
} from '../nodes';

export const normalizeMention = <E extends AutocompleteInputElement>(
  editor: BufferEditor,
  elementInterface: AutocompleteInputElementInterface<E>,
  nodeEntry: TNodeEntry
): boolean => {
  const [node, path] = nodeEntry;

  if (elementInterface.is(node)) {
    const currentMentionText = getEditorString(editor, path);

    if (!currentMentionText.startsWith(elementInterface.trigger)) {
      unwrapNodes(editor, {
        at: path,
        match: (n) => elementInterface.is(n),
      });
      return true;
    }

    if (setNodeValidityAgainstRegex(editor, elementInterface, nodeEntry)) {
      return true;
    }
  }

  return false;
};
